import React, { useContext, useEffect, useRef } from "react";
import styles from "./Quote.module.scss";
import MobileContext from "../../context/mobile";
import clsx from 'clsx';

const Quote = (props) => {
  const { text, textMobile, color, className } = props;

  const isMobile = useContext(MobileContext);
  const refWrap = useRef(null);
  let wrapClass = `${styles.wrap}`;
  if (color !== undefined && styles[`wrap_${color}`] !== undefined) {
    wrapClass += ` ${styles[`wrap_${color}`]}`;
  }
  useEffect(() => {
    const wrap = refWrap.current;
    const animateObserver = (element) => {
      let options = {
        threshold: 0.5,
        rootMargin: '0% 0% -10% 0%'
      }
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            element.classList.add(styles.animate);
            observer.unobserve(element);
            // } else {
            //   element.classList.remove('fixed');
          }
        })
      }, options);
      observer.observe(element);
    }
    animateObserver(wrap);
  }, []);
  let rows = [];
  if (isMobile && textMobile !== undefined) {
    textMobile.forEach((element, index) => {
      rows.push(<div className={styles.row} key={`text-row-${index}`}>
        <span>{element}</span>
      </div>);

    });
  } else {
    text.forEach((element, index) => {
      rows.push(<div className={styles.row} key={`text-row-${index}`}>
        <span>{element}</span>
      </div>);

    });
  }
  return (
    <>
      <div className={clsx(wrapClass, className)} ref={refWrap}>
        {rows}
      </div>
    </>
  );

}

export default Quote;
